import { Action } from '@ngrx/store';

export enum MapaBaseActionTypes {
    GET_MAPABASE = '[MB] GET_MAPABASE',
    GET_MAPABASE_SUCCESS = '[MB] GET_MAPABASE Success',
    GET_MAPABASE_FAILURE = '[MB] GET_MAPABASE Failure'
}

export class GetMapaBase implements Action {
  readonly type = MapaBaseActionTypes.GET_MAPABASE;
  constructor(public contenedor: string) {}
}
export class GetMapaBaseSuccess implements Action {
  readonly type = MapaBaseActionTypes.GET_MAPABASE_SUCCESS;
  constructor(public mapaBase: { [key: string]: boolean; }) {
  }
}

export class GetMapaBaseFailure implements Action {
  readonly type = MapaBaseActionTypes.GET_MAPABASE_FAILURE;
  constructor(public payload: any) {}
}

export type mapaBaseAcciones =
  | GetMapaBase
  | GetMapaBaseSuccess
  | GetMapaBaseFailure;
